import { render, staticRenderFns } from "./sumProblem_division.vue?vue&type=template&id=0c912f68&scoped=true"
import script from "./sumProblem_division.vue?vue&type=script&lang=js"
export * from "./sumProblem_division.vue?vue&type=script&lang=js"
import style0 from "./sumProblem_division.vue?vue&type=style&index=0&id=0c912f68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c912f68",
  null
  
)

export default component.exports